export default "__VITE_ASSET__BNTo0AR0__"